import React from "react";
import { AiOutlineInsurance } from "react-icons/ai";
import { FaCarBattery, FaOilCan, FaRegCalendarAlt } from "react-icons/fa";
import {
  GiBelt,
  GiCartwheel,
  GiCarWheel,
  GiSteeringWheel,
} from "react-icons/gi";
import { RiWaterPercentFill } from "react-icons/ri";
import { RiOilFill } from "react-icons/ri";
import { MdElectricBolt, MdHealthAndSafety } from "react-icons/md";
import { GiSparkPlug } from "react-icons/gi";
import { LiaOilCanSolid } from "react-icons/lia";
import { TbCarTurbine } from "react-icons/tb";
import { ImFilter } from "react-icons/im";
import { SiSpeedtest } from "react-icons/si";

const ServiceIcon = ({ categoryId }) => {
  let pic;
  switch (categoryId) {
    case "1":
      pic = <RiOilFill size={25} />;
      break;

    case "2":
      pic = <GiBelt size={25} />;
      break;

    case "3":
      pic = <FaOilCan size={25} />;
      break;

    case "4":
      pic = <MdElectricBolt size={25} />;
      break;

    case "5":
      pic = <GiSparkPlug size={25} />;
      break;

    case "6":
      pic = <GiCartwheel size={25} />;
      break;

    case "7":
      pic = <GiSteeringWheel size={25} />;
      break;

    case "8":
      pic = <LiaOilCanSolid size={25} />;
      break;

    case "9":
      pic = <TbCarTurbine size={25} />;
      break;

    case "10":
      pic = <GiCarWheel size={25} />;
      break;

    case "11":
      pic = <ImFilter size={25} />;
      break;

    case "12":
      pic = <MdHealthAndSafety size={25} />;
      break;

    case "13":
      pic = <AiOutlineInsurance size={25} />;
      break;

    case "14":
      pic = <RiWaterPercentFill size={25} />;
      break;

    case "15":
      pic = <FaCarBattery size={25} />;
      break;

    case "90":
      pic = <FaRegCalendarAlt size={25} />;
      break;

    case "91":
      pic = <SiSpeedtest size={25} />;
      break;

    default:
      pic = <FaOilCan size={25} />;
      break;
  }

  return <>{pic}</>;
};

export default ServiceIcon;
